import { render, staticRenderFns } from "./DeliveryDay.vue?vue&type=template&id=79c47a3d&scoped=true&"
import script from "./DeliveryDay.vue?vue&type=script&lang=js&"
export * from "./DeliveryDay.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryDay.vue?vue&type=style&index=0&id=79c47a3d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c47a3d",
  null
  
)

export default component.exports